import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';

var COLOR_ARRAY_BASE = ['sapphire', 'ruby', 'aquamarine', 'amethyst', 'turquoise', 'onyx', 'amber', 'canary'];
var getAvatarColor = function getAvatarColor(text) {
  if (text === undefined) {
    text = 'AA';
  }
  var name = text.split('@')[0] // if email is passed, omit the domain to only use username
  .replace(/[.\-_ ]/g, '') // remove special characters
  .toLowerCase();
  var hash = name.split('').reduce(function (acc, c) {
    return acc + c.charCodeAt(0);
  }, 0);
  var colorIndex = hash % COLOR_ARRAY_BASE.length;
  return COLOR_ARRAY_BASE[colorIndex];
};

export { getAvatarColor };
